import React from 'react'
import './Badge.css'

type Props = {
  type?: 'neutral' | 'info' | 'success' | 'warning' | 'error'
  children: React.ReactNode
} & React.HTMLAttributes<HTMLSpanElement>

export function Badge({ type = 'neutral', children, ...props }: Props) {
  return (
    <span data-color={type} className="badge" {...props}>
      {children}
    </span>
  )
}
